function toElement(html: string): ChildNode | null {
    const elTemplate = document.createElement('template');
    // Never return a text node of whitespace as the result
    elTemplate.innerHTML = html.trim();

    return elTemplate.content.firstChild;
}

// ----------------------------------------------------------------------------

declare global {
    interface String {
        toElement(): ChildNode | null;
    }
}

// ----------------------------------------------------------------------------

String.prototype.toElement = function (): ChildNode | null {
    return toElement(this as string);
};

// ----------------------------------------------------------------------------

export default toElement;
